import { Skeleton, Tooltip } from "@mui/material";
import PropTypes from "prop-types";
import styled from "styled-components";

const StyledDiv = styled.div`
  width: ${(props) => props.$size}px;
  height: ${(props) => props.$size}px;
  background-color: ${(props) => (props.$isLoading ? "inherit" : props.$status.style)};
  border-radius: ${(props) => props.$borderRadius}px;
  border: 1px solid gray;
  transition: all 0.3s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  font-size: 0.8em;
  opacity: ${(props) => props.opacity};
`;

export default function PersonPvmStatusIndicatorBox({
  status,
  includePrefix = true,
  size = 20,
  borderRadius = 2,
  opacity = 0.8,
  isLoading = false,
}) {
  // if (!status) return null;
  const prefix = includePrefix ? status.prefix : "";
  return (
    <Tooltip title={status.personPvmStatus} placement="left" disableInteractive>
      <StyledDiv
        $size={size}
        $status={status}
        $borderRadius={borderRadius}
        opacity={opacity}
        $isLoading={isLoading}>
        {(isLoading || !status) && <Skeleton width={size * 2} height={size * 2} animation="wave" />}
        <span style={{ opacity: 0.8, fontSize: (size * 2) / 3.5 }}>{prefix}</span>
      </StyledDiv>
    </Tooltip>
  );
}

PersonPvmStatusIndicatorBox.propTypes = {
  status: PropTypes.object,
  includePrefix: PropTypes.bool,
  size: PropTypes.number,
  borderRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  opacity: PropTypes.number,
  isLoading: PropTypes.bool,
};
